import { SearchIcon } from '@heroicons/react/outline';
import clsx, { ClassValue } from 'clsx';
import Button from 'components/Button';
import React, { FC, useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

interface ITableSearch {
  totalCount: number;
  search: string;
  onSearch: (search: string) => void;
  className?: ClassValue;
  theme?: 'default' | 'version-1';
}

const themes = {
  default: {
    searchWrapper: '',
    input: 'rounded-full border-gray-500'
  },
  'version-1': {
    searchWrapper: 'justify-end w-full mr-5',
    input: 'rounded-l-lg'
  }
};

const TableSearch: FC<ITableSearch> = ({
  totalCount,
  search,
  onSearch,
  className,
  theme = 'default'
}) => {
  const [value, setValue] = useState<string>(search);
  const [showSearch, setShowSearch] = useState<boolean>(false);

  const handleDebounceSearch = useDebouncedCallback((value: string) => {
    onSearch(value);
  }, 1000);

  useEffect(() => {
    if (theme === 'default') {
      setShowSearch(true);
    }
  }, [theme]);

  return (
    <div className={clsx('space-x-3 flex items-center', className, themes[theme].searchWrapper)}>
      {theme === 'default' && <span> Search: </span>}
      <div className="flex items-center">
        {showSearch && (
          <input
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
              handleDebounceSearch(e.target.value);
            }}
            placeholder={`${totalCount} records...`}
            className={clsx('text-xs border p-2', themes[theme].input)}
            autoFocus={showSearch}
          />
        )}

        {theme !== 'default' && (
          <Button
            variant="invisible"
            size="inline"
            className="bg-hazel-light-green-600 rounded-t-lg rounded-b-none"
            classNameButton="py-2 px-4"
            onClick={() => setShowSearch(!showSearch)}
          >
            <SearchIcon className="text-white h-5 w-5" />
          </Button>
        )}
      </div>
    </div>
  );
};

export default TableSearch;
